// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Bkz_","tab":"ProcedureTabs_tab__ikXT8"};